const FeedLotsIcon = (props: any) => {
    return (
        <img {...props} alt="feedlots.png" src={require('./feedlots.png')} />
    );
};

export default FeedLotsIcon;
